angular.module('app.productService', [])
  .factory('app.productService', [
    'PRODUCT',
    function (PRODUCT) {
      "use strict";

      let service = {
        useTeamSubscriptions: () => {
          switch (PRODUCT.Code) {
            case 'ahl':
              return true;
            case 'htv':
            default:
              return false;
          }
        },

        isSubscriptionPauseEnabled:  () => {
          switch (PRODUCT.Code) {
            case 'ahl':
              return false;
            case 'htv':
            default:
              return true;
          }
        },

        isSubscriptionUpgradeableIfCancelled:  () => {
          switch (PRODUCT.Code) {
            case 'ahl':
              return true;
            case 'htv':
            default:
              return false;
          }
        },

        planUsesTeams:  (plan) => {
          switch (PRODUCT.Code) {
            case 'ahl':
              switch (plan.type) {
                case 'league':
                case 'global':
                default:
                  return false;
                case 'team_all':
                case 'team_home':
                case 'team_away':
                  return true;
              }
              break;
            case 'htv':
              switch (plan.type) {
                case 'global':
                default:
                  return false;
              }
          }
        },
      };

      return service;
    }
  ]);


// WEBPACK FOOTER //
// ./app.v2/components/fhApp/productService.js